import { Tooltip, Avatar, Container, Stack, Grid, Box, FormControlLabel, RadioGroup, FormControl, Radio, TextField, InputAdornment, Divider, Button } from "@mui/material";
import { useState } from "react";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import Alert from '@mui/material/Alert';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ATLANTIDA from '../participante/LogosBancos/ATLANTIDA.png'
import PaginationItem from '@mui/material/PaginationItem';
import AZTECA from '../participante/LogosBancos/AZTECA.png'
import IdentidadEjemplo from './IdentidadEjemplo.jpg'
import BANPAIS from '../participante/LogosBancos/BANPAIS.png'
import FICOHSA from '../participante/LogosBancos/FICOHSA.png'
import LAFISE from '../participante/LogosBancos/LAFISE.png'
import FICENSA from '../participante/LogosBancos/FICENSA.png'
import DAVIVIENDA from '../participante/LogosBancos/DAVIVIENDA.png'
import PROMERICA from '../participante/LogosBancos/PROMERICA.png'
import BANRURAL from '../participante/LogosBancos/BANRURAL.png'
import POPULAR from '../participante/LogosBancos/POPULAR.png'
import BAC from '../participante/LogosBancos/BAC.png'
import CITI from '../participante/LogosBancos/CITI.png'
import BANADESA from '../participante/LogosBancos/BANADESA.png'
import BANHPROVI from '../participante/LogosBancos/BANHPROVI.png'
import BANHCAFE from '../participante/LogosBancos/BANHCAFE.png'
import OCCIDENTE from '../participante/LogosBancos/OCCIDENTE.png'
import TRABAJADORES from '../participante/LogosBancos/TRABAJADORES.png'
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Desplegable from "./Components/Desplegable";
import classes from "./ParticipanteClasess.css";
import Aval from "./Components/aval1";
import Aval2 from "./Components/aval2";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Pagination from '@mui/material/Pagination';
import Autocomplete from '@mui/material/Autocomplete';
import * as React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Importa el archivo de localización para español
import SendIcon from '@mui/icons-material/Send';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Dialog, DialogTitle, DialogActions } from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
dayjs.locale('es'); // Establece el idioma local a español

function ParticipanteSolicitudesMovil() {
    const [currentPage, setCurrentPage] = useState(1);
    const [civil, setCivil] = useState('');
    const [tipoPrestamo, setTipoPrestamo] = useState('all');
    const [tipoVivienda, setTipoVivienda] = useState('all');
    const [departamentoSolicitante, setDepartamentoSolicitante] = useState('');
    const [banco, setBanco] = useState('');
    //const [bancosSeleccionados, setBancosSeleccionados] = useState(Array(5).fill(''));
    //const bancos=["Banco Atlántida S.A.","Banco de Occidente S.A.","Banco de Los Trabajadores","Banco Financiera Centroamericana S.A. (FICENSA)","Banco Hondureño del Café S.A. (BANHCAFE)","Banco del País S.A.","Banco Financiera Comercial Hondureña S.A. (FICOHSA)","Banco Lafise Honduras  S.A.","Banco Davivienda Honduras S.A.","Banco Promérica S.A.","Banco de Desarrollo Rural Honduras S.A.","Banco Azteca de Honduras S.A.","Banco Popular S.A.","Banco de América Central Honduras S.A. – Bac | Honduras","Banco de Honduras (Citi Honduras)"];
    const [salarioMensual, setSalarioMensual] = useState(0);
    const [selectedIdentidadSoli, setSelectedIdentidadSoli] = useState(null);
    const [consolidacionParcial, setConsolidacionParcial] = useState(0);
    const [consolidacionTotal, setConsolidacionTotal] = useState(0);
    const [ihss, setIhss] = useState(0);
    const [isr, setIsr] = useState(0);
    const [prestamoInjupemp, setPrestamoInjupemp] = useState(0);
    const [pensionJubilacion, setPensionJubilacion] = useState(0);
    const [embargos, setEmbargos] = useState(0);
    const [otrosingresos1, setOtrosIngresos1] = useState(0);
    const [otrosingresos2, setOtrosIngresos2] = useState(0);
    const [otrosingresos3, setOtrosIngresos3] = useState(0);
    const [otrosingresos4, setOtrosIngresos4] = useState(0);
    const [otrosingresos5, setOtrosIngresos5] = useState(0);
    const [otrosingresos6, setOtrosIngresos6] = useState(0);
    const [otrosingresos7, setOtrosIngresos7] = useState(0);
    const [totalDeducciones, setTotalDeducciones] = useState(0);
    const [cantidadNeta, setCantidadNeta] = useState(0);
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [selectedDateAval1, setSelectedDateAval1] = React.useState(null);
    const [selectedDateAval2, setSelectedDateAval2] = React.useState(null);
    const [fechaVacia, setFechaVacia] = React.useState(null);
    const [selectedDateIngreso, setSelectedDateIngreso] = React.useState(null);
    const [fechaVaciaIngreso, setFechaVaciaIngreso] = React.useState(null);
    const [numeroPaginas, setNumeroPaginas] = useState(9);
    const [tipoViviendaAval1, setTipoViviendaAval1] = useState('all');
    const [tipoViviendaAval2, setTipoViviendaAval2] = useState('all');
    const [formulario, setFormulario] = useState({
        NoSolicitud: '',
        NoCotizante: '',

        //Datos del solicitante página 2
        solicitanteIdentidad: '',
        solicitanteNombres: '',
        solicitanteApellidos: '',
        solicitanteNacimiento: null,
        solicitanteProfesion: '',
        solicitanteBarrio: '',
        solicitanteAve: '',
        solicitanteCalle: '',
        solicitanteCasa: '',
        solicitanteCiudad: '',
        solicitanteDepartamento: '',
        solicitanteReferenciaDomicilio: '',
        solicitanteFijo: '',
        solicitanteMovil: '',
        solicitanteCorreo: '',
        estadocivilSolicitante: '',
        departamentoSolicitante: '',

        //Información laboral solicitante página 3
        laboralDependencia: '',
        laboralRamo: '',
        laboralBarrio: '',
        laboralAve: '',
        laboralCalle: '',
        laboralCasa: '',
        laboralCiudad: '',
        laboralDepartamento: '',
        laboralTelefono: '',
        sueldoMensualsoli: '',
        otrosIngresossoli: '',
        sueldoNetosoli: '',
        laboralPuesto: '',
        laboralYears: '',
        laboralMeses: '',
        tipoVivienda: '',

        //Referencias Personales página 4
        referencia1Nombres: '',
        referencia1Parentesco: '',
        referencia1Direccion: '',
        referencia1Telefono: '',
        referencia2Nombres: '',
        referencia2Parentesco: '',
        referencia2Direccion: '',
        referencia2Telefono: '',

        //aval1 página 5
        aval1Identidad: '',
        aval1Nombres: '',
        aval1Apellidos: '',
        aval1Nacimiento: null,
        aval1Profesion: '',
        aval1Barrio: '',
        aval1Ave: '',
        aval1Calle: '',
        aval1Casa: '',
        estadocivilAval1: '',
        aval1Ciudad: '',
        aval1Departamento: '',
        aval1ReferenciaDomicilio: '',
        aval1Correo: '',
        aval1Dependencia: '',
        aval1Ramo: '',
        aval1BarrioTrabajo: '',
        aval1AveTrabajo: '',
        aval1CalleTrabajo: '',
        aval1CasaTrabajo: '',
        aval1CiudadTrabajo: '',
        sueldoMensualAval1: '',
        otrosIngresosAval1: '',
        sueldoNetoAval1: '',
        aval1Puesto: '',
        aval1Years: '',
        aval1Meses: '',
        aval1Departamentotrabajo: '',

        //aval2 página 6
        aval2Identidad: '',
        aval2Nombres: '',
        aval2Apellidos: '',
        aval2Nacimiento: null,
        aval2Profesion: '',
        aval2Barrio: '',
        aval2Ave: '',
        aval2Calle: '',
        aval2Casa: '',
        estadocivilAval2: '',
        aval2Ciudad: '',
        aval2Departamento: '',
        aval2ReferenciaDomicilio: '',
        aval2Correo: '',
        aval2Dependencia: '',
        aval2Ramo: '',
        aval2BarrioTrabajo: '',
        aval2AveTrabajo: '',
        aval2CalleTrabajo: '',
        aval2CasaTrabajo: '',
        aval2CiudadTrabajo: '',
        sueldoMensualAval2: '',
        otrosIngresosAval2: '',
        sueldoNetoAval2: '',
        aval2Puesto: '',
        aval2Years: '',
        aval2Meses: '',
        aval2Departamentotrabajo: '',

        //transferencia de pago página 7
        solicitanteBancoCuenta: '',
        nocuenta: '',

        //página 9
        rrhhSalarioMensual: '',
        ihss: '',
        isr: '',
        prestamoconinjupemp: '',
        pensionjubilacion: '',
        embargos: '',
        otrodetalle1: '',
        otrodetalle2: '',
        otrodetalle3: '',
        otrodetalle4: '',
        otrodetalle5: '',
        otrodetalle6: '',
        otrodetalle7: '',

        rrhhingreso: null,
    });

    // Funciones para manejar cambios en los campos y actualizar el estado
    const handleChange = (event) => {
        const { id, value } = event.target;
        setFormulario(prevState => ({
            ...prevState,
            [id]: value
        }));

        //console.log(formulario.solicitanteDepartamento);
    };

    const handleDateChange = (id, date) => {
        setFormulario(prevState => ({
            ...prevState,
            [id]: date
        }));
    };

    function CustomDatePickerNacimiento(props) {
        const today = dayjs();
        const [invalidFormat, setInvalidFormat] = React.useState(false);
        const [cleared, setCleared] = React.useState(false);

        React.useEffect(() => {
            if (cleared) {
                setSelectedDate(null);
                const timeout = setTimeout(() => {
                    setCleared(false);
                }, 1500);

                return () => clearTimeout(timeout);
            }
            return () => { };
        }, [cleared]);

        const handleDateChange = (date) => {
            if (date && !dayjs(date, "DD/MM/YYYY").isValid()) {
                setInvalidFormat(true);
            } else {
                setInvalidFormat(false);
                setSelectedDate(date);
                setFechaVacia(false);
            }
        };

        const handleKeyDown = (event) => {
            event.preventDefault(); // Evitar la entrada manual
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                        format={"DD/MM/YYYY"}
                        value={selectedDate}
                        views={['year', 'month', 'day']}
                        //onChange={handleDateChange}
                        onAccept={handleDateChange}
                        slotProps={{
                            field: { clearable: true, onClear: () => setCleared(true) },
                            textField: {
                                helperText: fechaVacia ? 'Seleccione la fecha de nacimiento' : invalidFormat ? "Formato de fecha incorrecto" : (selectedDate && dayjs(selectedDate).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" : null),
                                error: fechaVacia || invalidFormat,
                                onKeyDown: handleKeyDown
                            },
                        }}
                        maxDate={today}
                        {...props}
                    />
                </DemoItem>
                {cleared && (
                    <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                    >
                        Fecha Borrada!
                    </Alert>
                )}
            </LocalizationProvider>

        );
    }

    function CustomDatePickerNacimiento1(props) {
        const today = dayjs();
        const [invalidFormat, setInvalidFormat] = React.useState(false);
        const [cleared, setCleared] = React.useState(false);

        React.useEffect(() => {
            if (cleared) {
                setSelectedDateAval1(null);
                const timeout = setTimeout(() => {
                    setCleared(false);
                }, 1500);

                return () => clearTimeout(timeout);
            }
            return () => { };
        }, [cleared]);

        const handleDateChange1 = (date) => {
            if (date && !dayjs(date, "DD/MM/YYYY").isValid()) {
                setInvalidFormat(true);
            } else {
                setInvalidFormat(false);
                setSelectedDateAval1(date);
                setFechaVacia(false);
            }
        };

        const handleKeyDown = (event) => {
            event.preventDefault(); // Evitar la entrada manual
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                        format={"DD/MM/YYYY"}
                        value={selectedDateAval1}
                        views={['year', 'month', 'day']}
                        //onChange={handleDateChange}
                        onAccept={handleDateChange1}
                        slotProps={{
                            field: { clearable: true, onClear: () => setCleared(true) },
                            textField: {
                                helperText: fechaVacia ? 'Seleccione la fecha de nacimiento' : invalidFormat ? "Formato de fecha incorrecto" : (selectedDateAval1 && dayjs(selectedDateAval1).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" : null),
                                error: fechaVacia || invalidFormat,
                                onKeyDown: handleKeyDown
                            },
                        }}
                        maxDate={today}
                        {...props}
                    />
                </DemoItem>
                {cleared && (
                    <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                    >
                        Fecha Borrada!
                    </Alert>
                )}
            </LocalizationProvider>

        );
    }

    function CustomDatePickerNacimiento2(props) {
        const today = dayjs();
        const [invalidFormat, setInvalidFormat] = React.useState(false);
        const [cleared, setCleared] = React.useState(false);

        React.useEffect(() => {
            if (cleared) {
                setSelectedDateAval2(null);
                const timeout = setTimeout(() => {
                    setCleared(false);
                }, 1500);

                return () => clearTimeout(timeout);
            }
            return () => { };
        }, [cleared]);

        const handleDateChange2 = (date) => {
            if (date && !dayjs(date, "DD/MM/YYYY").isValid()) {
                setInvalidFormat(true);
            } else {
                setInvalidFormat(false);
                setSelectedDateAval2(date);
                setFechaVacia(false);
            }
        };

        const handleKeyDown = (event) => {
            event.preventDefault(); // Evitar la entrada manual
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                        format={"DD/MM/YYYY"}
                        value={selectedDateAval2}
                        views={['year', 'month', 'day']}
                        //onChange={handleDateChange}
                        onAccept={handleDateChange2}
                        slotProps={{
                            field: { clearable: true, onClear: () => setCleared(true) },
                            textField: {
                                helperText: fechaVacia ? 'Seleccione la fecha de nacimiento' : invalidFormat ? "Formato de fecha incorrecto" : (selectedDateAval2 && dayjs(selectedDateAval2).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" : null),
                                error: fechaVacia || invalidFormat,
                                onKeyDown: handleKeyDown
                            },
                        }}
                        maxDate={today}
                        {...props}
                    />
                </DemoItem>
                {cleared && (
                    <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                    >
                        Fecha Borrada!
                    </Alert>
                )}
            </LocalizationProvider>

        );
    }

    function transferenciadepago() {
        return (
            <Stack direction="column">
                <Box>
                    <Stack>
                        <h3 >VIII. TRANSFERENCIA DE PAGO DEL MONTO APROBADO A CUENTA BANCARIA</h3>
                    </Stack>
                    <h4>INFORMACIÓN DEL BANCO</h4>
                    <Grid container>
                        <Stack direction="column">
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <label htmlFor="bancoTipoCuenta"><strong>Tipo de Cuenta</strong></label>
                                <RadioGroup row aria-labelledby="Tipo Cuenta Bano" name="tipoCuentaBanco">
                                    <FormControlLabel value="cuenta1" control={<Radio color="error" />} label="Ahorro" />
                                    <FormControlLabel value="cuenta2" control={<Radio color="error" />} label="Cheque" />
                                </RadioGroup>
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <Autocomplete
                                    id="solicitanteBancoCuenta"
                                    {...defaultPropsBancos}
                                    value={selectedBancoCuenta}
                                    onChange={handleBancoChange}
                                    renderInput={(params) => (
                                        <TextField {...params} id="solicitanteBancoCuenta" placeholder="Ingrese el nombre del banco" label="Nombre del Banco" variant="outlined"
                                            error={Boolean(errors.solicitanteBancoCuenta)}
                                            onBlur={handleBlur}
                                            helperText={errors.solicitanteBancoCuenta} />
                                    )}

                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField placeholder="Ingrese el número de cuenta" id="nocuenta" label="No. de Cuenta" variant="outlined" onInput={validarSoloNumeros}
                                    value={formulario.nocuenta}
                                    onChange={handleChange}
                                    error={Boolean(errors.nocuenta)}
                                    onBlur={handleBlur}
                                    helperText={errors.nocuenta}
                                />
                            </FormControl>
                        </Stack>
                    </Grid>

                </Box>
            </Stack>
        );
    }

    function CustomDatePickerIngreso(props) {
        const today = dayjs();
        const [invalidFormatIngreso, setInvalidFormatIngreso] = React.useState(false);

        const [cleared, setCleared] = React.useState(false);

        React.useEffect(() => {
            if (cleared) {
                setSelectedDateIngreso(null);
                const timeout = setTimeout(() => {
                    setCleared(false);
                }, 1500);

                return () => clearTimeout(timeout);
            }
            return () => { };
        }, [cleared]);

        const handleDateChangeIngreso = (date) => {
            if (date && !dayjs(date, "DD/MM/YYYY").isValid()) {
                setInvalidFormatIngreso(true);
            } else {
                setInvalidFormatIngreso(false);
                setSelectedDateIngreso(date);
                setFechaVaciaIngreso(false);
            }
        };

        const handleKeyDown = (event) => {
            event.preventDefault(); // Evitar la entrada manual
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                        format={"DD/MM/YYYY"}
                        value={selectedDateIngreso}
                        views={['year', 'month', 'day']}
                        //onChange={handleDateChange}
                        onAccept={handleDateChangeIngreso}
                        slotProps={{
                            field: { clearable: true, onClear: () => setCleared(true) },
                            textField: {
                                helperText: fechaVaciaIngreso ? 'Seleccione la fecha de ingreso' : invalidFormatIngreso ? "Formato de fecha incorrecto" : (selectedDateIngreso && dayjs(selectedDateIngreso).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" : null),
                                error: fechaVaciaIngreso || invalidFormatIngreso,
                                onKeyDown: handleKeyDown
                            },
                        }}
                        maxDate={today}
                        {...props}
                    />
                </DemoItem>
                {cleared && (
                    <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                    >
                        Fecha Borrada!
                    </Alert>
                )}
            </LocalizationProvider>
        );
    }

    const [selectedDepartamentoSolicitante, setSelectedDepartamentoSolicitante] = useState(null);
    const [selectedDepartamentoLaboralSolicitante, setSelectedDepartamentoLaboralSolicitante] = useState(null);
    const [selectedDepartamentoAval1, setSelectedDepartamentoAval1] = useState(null);
    const [selectedDepartamentoLaboralAval1, setSelectedDepartamentoLaboralAval1] = useState(null);
    const [selectedDepartamentoAval2, setSelectedDepartamentoAval2] = useState(null);
    const [selectedDepartamentoLaboralAval2, setSelectedDepartamentoLaboralAval2] = useState(null);
    const [selectedBancoCuenta, setSelectedBancoCuenta] = useState(null);

    const handleDepartamentoChange = (event, value) => {
        setSelectedDepartamentoSolicitante(value);
    };
    const handleDepartamentoLaboralChange = (event, value) => {
        setSelectedDepartamentoLaboralSolicitante(value);
    };
    const handleDepartamentoAval1Change = (event, value) => {
        setSelectedDepartamentoAval1(value);
    };
    const handleDepartamentoLaboralAval1Change = (event, value) => {
        setSelectedDepartamentoLaboralAval1(value);
    };
    const handleDepartamentoAval2Change = (event, value) => {
        setSelectedDepartamentoAval2(value);
    };
    const handleDepartamentoLaboralAval2Change = (event, value) => {
        setSelectedDepartamentoLaboralAval2(value);
    };
    const handleBancoChange = (event, value) => {
        setSelectedBancoCuenta(value);
    };

    const [selectedCivilSolicitante, setSelectedCivilSolicitante] = useState(null);
    const [selectedCivilAval1, setSelectedCivilAval1] = useState(null);
    const [selectedCivilAval2, setSelectedCivilAval2] = useState(null);

    const handleCivilChange = (event, value) => {
        setSelectedCivilSolicitante(value);
    };
    const handleCivilAval1Change = (event, value) => {
        setSelectedCivilAval1(value);
    };
    const handleCivilAval2Change = (event, value) => {
        setSelectedCivilAval2(value);
    };


    const handleBlurSalario = () => {
        // Calcula el total de deducciones
        const totalDeducciones = ihss + isr + prestamoInjupemp + pensionJubilacion + embargos + otrosingresos1 + otrosingresos2 + otrosingresos3 + otrosingresos4 + otrosingresos5 + otrosingresos6 + otrosingresos7;
        setTotalDeducciones(totalDeducciones);

        // Calcula la cantidad neta que percibe al mes
        const cantidadNeta = salarioMensual - totalDeducciones;
        setCantidadNeta(cantidadNeta);
    };

    function handleTipoPrestamo(event) {
        if (event.target.value === "prestamo2") {
            setNumeroPaginas(9);
        } else {
            setNumeroPaginas(7);
        }
        setTipoPrestamo(event.target.value);
    }

    function handleTipoVivienda(event) {
        setTipoVivienda(event.target.value);
    }

    /*const handleBanco = (index, event) => {
        const newBancosSeleccionados = [...bancosSeleccionados];
        newBancosSeleccionados[index] = event.target.value;
        setBancosSeleccionados(newBancosSeleccionados);
    };*/

    /*function handleBancoCuenta(event){
        setBanco(event.target.value);
    }

    function handleDepartamento(event){
        setDepartamento(event.target.value);
    }
    const handleChange = (event) => {
        setCivil(event.target.value);
    };*/

    const defaultProps = {
        options: listadepartamentos,
        getOptionLabel: (option) => option.title,
    };
    const flatProps = {
        options: listadepartamentos.map((option) => option.title),
    };

    const renderOption = (props, option) => (
        <Box component="li" {...props} style={{ display: 'flex', alignItems: 'center' }}>
            <span>{option.title}</span>

            <img
                alt={option.title}
                src={option.title === 'Banco Azteca de Honduras S.A.' ? AZTECA :
                    option.title === 'Banco Atlántida S.A.' ? ATLANTIDA :
                        option.title === 'Banco de Occidente S.A.' ? OCCIDENTE :
                            option.title === 'Banco de Los Trabajadores' ? TRABAJADORES :
                                option.title === 'Banco Financiera Centroamericana S.A. (FICENSA)' ? FICENSA :
                                    option.title === 'Banco Hondureño del Café S.A. (BANHCAFE)' ? BANHCAFE :
                                        option.title === 'Banco del País S.A. (BANPAIS)' ? BANPAIS :
                                            option.title === 'Banco Financiera Comercial Hondureña S.A. (FICOHSA)' ? FICOHSA :
                                                option.title === 'Banco Davivienda Honduras S.A.' ? DAVIVIENDA :
                                                    option.title === 'Banco Promérica S.A.' ? PROMERICA :
                                                        option.title === 'Banco de Desarrollo Rural Honduras S.A.' ? BANRURAL :
                                                            option.title === 'Banco Popular S.A.' ? POPULAR :
                                                                option.title === 'Banco de América Central Honduras S.A. (BAC) | Honduras' ? BAC :
                                                                    option.title === 'Banco Lafise Honduras  S.A.' ? LAFISE :
                                                                        option.title === 'Banco de Honduras (Citi Honduras)' ? CITI :
                                                                            option.title === 'Banco Nacional de Desarrollo Agrícola (BANADESA)' ? BANADESA :
                                                                                option.title === 'Banco Hondureño para la Producción y la Vivienda (BANHPROVI)' ? BANHPROVI :
                                                                                    null} // Suponiendo que los logos están nombrados según el código del banco
                style={{ width: '20%', height: '20%', objectFit: 'contain', marginLeft: '10px' }}
            />
        </Box>
    );


    const defaultPropsBancos = {
        options: listabancos,
        getOptionLabel: (option) => option.title,
        renderOption: renderOption,
    };

    const defaultPropsCivil = {
        options: listacivil,
        getOptionLabel: (option) => option.title,
    };
    const flatPropsCivil = {
        options: listacivil.map((option) => option.title),
    };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    const validarSoloNumeros = (event) => {
        // Solo permitir números
        event.target.value = event.target.value.replace(/[^0-9]/g, '');
    };

    const validarSoloLetras = (event) => {
        // Solo permitir letras y espacio
        event.target.value = event.target.value.replace(/[^A-Za-z\s]/g, '');
    };

    /*---------------------Validación Longitudes Y Campos Vacíos* ---------------*/

    const [errors, setErrors] = useState({});

    const handleBlur = (event) => {
        const fieldName = event.target.id;
        const fieldValue = event.target.value;
        let errorMessage = '';

        // Validación para la identidad
        if (fieldName === 'solicitanteIdentidad') {
            if (fieldValue.length !== 13) {
                errorMessage = 'La identidad debe ser de 13 dígitos';
            }
        }

        if (fieldName === 'aval1Identidad') {
            if (fieldValue.length !== 13) {
                errorMessage = 'La identidad debe ser de 13 dígitos';
            }
        }

        // Validación para los números de teléfono
        if (fieldName === 'aval1Movil' || fieldName === 'aval1Fijo' || fieldName === 'aval1TelefonoTrabajo') {
            if (fieldValue.length !== 8) {
                errorMessage = 'El teléfono debe ser de 8 dígitos';
            }
        }

        if (fieldName === 'aval2Identidad') {
            if (fieldValue.length !== 13) {
                errorMessage = 'La identidad debe ser de 13 dígitos';
            }
        }

        // Validación para los números de teléfono
        if (fieldName === 'aval2Movil' || fieldName === 'aval2Fijo' || fieldName === 'aval2TelefonoTrabajo') {
            if (fieldValue.length !== 8) {
                errorMessage = 'El teléfono debe ser de 8 dígitos';
            }
        }

        // Validación para los números de teléfono
        if (fieldName === 'solicitanteMovil' || fieldName === 'solicitanteFijo' ||
            fieldName === 'laboralTelefono' || fieldName === 'referencia1Telefono'
            || fieldName === 'referencia2Telefono') {
            if (fieldValue.length !== 8) {
                errorMessage = 'El teléfono debe ser de 8 dígitos';
            }
        }

        // Validación para otros campos
        const fieldNamesToMessages = {
            solicitanteNombres: 'Ingrese los nombres del solicitante',
            solicitanteApellidos: 'Ingrese los apellidos del solicitante',
            solicitanteProfesion: 'Ingrese la profesión del solicitante',
            solicitanteBarrio: 'Ingrese el barrio del solicitante',
            solicitanteAve: 'Ingrese la avenida del solicitante',
            solicitanteCalle: 'Ingrese la calle del solicitante',
            solicitanteCasa: 'Ingrese el número de casa del solicitante',
            solicitanteCiudad: 'Ingrese la ciudad del solicitante',
            solicitanteDepartamento: 'Ingrese el departamento del solicitante',
            solicitanteReferenciaDomicilio: 'Ingrese una referencia del domicilio del solicitante',
            solicitanteCorreo: 'Ingrese el correo del solicitante',
            laboralDependencia: 'Ingrese la dependencia laboral del solicitante',
            laboralRamo: 'Ingrese el ramo laboral del solicitante',
            laboralBarrio: 'Ingrese el barrio laboral del solicitante',
            laboralAve: 'Ingrese la avenida laboral del solicitante',
            laboralCalle: 'Ingrese la calle laboral del solicitante',
            laboralCasa: 'Ingrese el número de casa laboral del solicitante',
            sueldoMensualsoli: 'Ingrese el sueldo mensual del solicitante',
            laboralCiudad: 'Ingrese la ciudad laboral del solicitante',
            laboralDepartamento: 'Ingrese el departamento laboral del solicitante',
            otrosIngresossoli: 'Ingrese otros ingresos del solicitante',
            sueldoNetosoli: 'Ingrese el sueldo neto del solicitante',
            laboralPuesto: 'Ingrese el puesto laboral del solicitante',
            laboralYears: 'Ingrese los años de experiencia laboral del solicitante',
            laboralMeses: 'Ingrese los meses de experiencia laboral del solicitante',
            rrhhSalarioMensual: 'Ingrese el salario nominal mensual del solicitante',
            ihss: 'Ingrese el IHSS',
            pensionjubilacion: 'Ingrese la pensión o jubilación',
            nocuenta: 'Ingrese el número de cuenta',
            estadocivilSolicitante: 'Ingrese el estado civil del solicitante',
            solicitanteBancoCuenta: 'Ingrese el banco de la cuenta del solicitante',
            referencia1Nombres: 'Ingrese el nombre de la referencia personal 1',
            referencia1Parentesco: 'Ingrese el parentesco de la referencia personal 1',
            referencia1Direccion: 'Ingrese la dirección de la referencia personal 1',
            referencia1Telefono: 'Ingrese el teléfono de la referencia personal 1',
            referencia2Nombres: 'Ingrese el nombre de la referencia personal 2',
            referencia2Parentesco: 'Ingrese el parentesco de la referencia personal 2',
            referencia2Direccion: 'Ingrese la dirección de la referencia personal 2',
            referencia2Telefono: 'Ingrese el teléfono de la referencia personal 2',
            solicitanteBancoCuentaConsolidar1: 'Ingrese el nombre del banco',
            lempirasconsolidar1: 'Ingrese valor lempiras',
            dolaresconsolidar1: 'Ingrese valor dólares',
            consolidacionparcial1: 'Ingrese valor parcial',

            //Aval 1
            aval1Nombres: 'Ingrese los nombres del aval 1',
            aval1Apellidos: 'Ingrese los apellidos del aval 1',
            aval1Profesion: 'Ingrese la profesión del aval 1',
            aval1Barrio: 'Ingrese el barrio del aval 1',
            aval1Ave: 'Ingrese la avenida del aval 1',
            aval1Calle: 'Ingrese la calle del aval 1',
            aval1Casa: 'Ingrese el número de casa del aval 1',
            aval1Ciudad: 'Ingrese la ciudad del aval 1',
            aval1Departamento: 'Ingrese el departamento del aval 1',
            aval1ReferenciaDomicilio: 'Ingrese una referencia del domicilio del aval 1',
            aval1Correo: 'Ingrese el correo del aval 1',
            aval1Dependencia: 'Ingrese la dependencia laboral del aval 1',
            aval1Ramo: 'Ingrese el ramo laboral del aval 1',
            aval1BarrioTrabajo: 'Ingrese el barrio laboral del aval 1',
            aval1AveTrabajo: 'Ingrese la avenida laboral del aval 1',
            estadocivilAval1: 'Ingrese el estado civil del aval1',
            aval1CalleTrabajo: 'Ingrese la calle laboral del aval 1',
            aval1CasaTrabajo: 'Ingrese el número de casa laboral del aval 1',
            aval1CiudadTrabajo: 'Ingrese la ciudad laboral del aval 1',
            sueldoMensualAval1: 'Ingrese el sueldo mensual del aval 1',
            otrosIngresosAval1: 'Ingrese otros ingresos del aval 1',
            sueldoNetoAval1: 'Ingrese el sueldo neto del aval 1',
            aval1Puesto: 'Ingrese el puesto laboral del aval 1',
            aval1Years: 'Ingrese los años de experiencia laboral del aval 1',
            aval1Meses: 'Ingrese los meses de experiencia laboral del aval 1',
            aval1Departamentotrabajo: 'Ingrese el departamento laboral del aval 1',

            //Aval 2
            aval2Nombres: 'Ingrese los nombres del aval 2',
            aval2Apellidos: 'Ingrese los apellidos del aval 2',
            aval2Profesion: 'Ingrese la profesión del aval 2',
            aval2Barrio: 'Ingrese el barrio del aval 2',
            aval2Ave: 'Ingrese la avenida del aval 2',
            aval2Calle: 'Ingrese la calle del aval 2',
            aval2Casa: 'Ingrese el número de casa del aval 2',
            aval2Ciudad: 'Ingrese la ciudad del aval 2',
            aval2Departamento: 'Ingrese el departamento del aval 2',
            aval2ReferenciaDomicilio: 'Ingrese una referencia del domicilio del aval 2',
            aval2Correo: 'Ingrese el correo del aval 2',
            aval2Dependencia: 'Ingrese la dependencia laboral del aval 2',
            aval2Ramo: 'Ingrese el ramo laboral del aval 2',
            aval2BarrioTrabajo: 'Ingrese el barrio laboral del aval 2',
            aval2AveTrabajo: 'Ingrese la avenida laboral del aval 2',
            estadocivilAval2: 'Ingrese el estado civil del aval 2',
            aval2CalleTrabajo: 'Ingrese la calle laboral del aval 2',
            aval2CasaTrabajo: 'Ingrese el número de casa laboral del aval 2',
            aval2CiudadTrabajo: 'Ingrese la ciudad laboral del aval 2',
            sueldoMensualAval2: 'Ingrese el sueldo mensual del aval 2',
            otrosIngresosAval2: 'Ingrese otros ingresos del aval 2',
            sueldoNetoAval2: 'Ingrese el sueldo neto del aval 2',
            aval2Puesto: 'Ingrese el puesto laboral del aval 2',
            aval2Years: 'Ingrese los años de experiencia laboral del aval 2',
            aval2Meses: 'Ingrese los meses de experiencia laboral del aval 2',
            aval2Departamentotrabajo: 'Ingrese el departamento laboral del aval 2'
        };

        if (fieldNamesToMessages.hasOwnProperty(fieldName)) {
            if (fieldValue.length < 1) {
                errorMessage = fieldNamesToMessages[fieldName];
            }
        }

        setErrors({
            ...errors,
            [fieldName]: errorMessage
        });
    };

    function handleTipoViviendaAval1(event) {
        setTipoViviendaAval1(event.target.value);
    }

    function handleTipoViviendaAval2(event) {
        setTipoViviendaAval2(event.target.value);
    }

    const handleDragOverIdentidadSoli = (event) => {
        event.preventDefault();
    };

    const handleDropIdentidadSoli = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedIdentidadSoli(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    const handleClickIdentidadSoli = () => {
        document.getElementById('selectedIdentidadSoli').click();
    };

    const handleFileChangeIdentidadSoli = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedIdentidadSoli(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    /*---------------------FINAL Validación Longitudes Y Campos Vacíos* ---------------*/

    const validateErrors = (props) => {

        // Obtener todos los elementos de entrada dentro del formulario
        const inputFields = document.querySelectorAll('input');

        // Objeto para almacenar los valores de los campos de entrada
        const fieldValues = {};

        // Iterar sobre los elementos de entrada y obtener sus valores
        inputFields.forEach(input => {
            fieldValues[input.id] = input.value;
        });

        // Objeto para almacenar los mensajes de error
        let errorMessages = {};

        if (tipoPrestamo === 'all') {
            errorMessages[0] = '-Seleccione el tipo de préstamo a solicitar en el inicio del formulario.'
        } else {

            // Ejecutar la lógica de validación para cada campo
            Object.entries(fieldValues).forEach(([fieldName, fieldValue]) => {
                let errorMessage = '';

                if (!selectedDate) {
                    errorMessages['solicitanteNacimiento'] = '-Seleccione la fecha de nacimiento del solicitante';
                    setFechaVacia(true);
                }

                /*if(formulario.solicitanteNombres===''){
                    errorMessages['solicitanteNombres']='-Ingrese el nombre del solicitante.';
                }*/

                if (tipoVivienda === 'all') {
                    errorMessages['tipoVivienda'] = '-Seleccione el tipo de vivienda del solicitante.';
                }

                if (!selectedDateIngreso) {
                    errorMessages['rrhhingreso'] = '-Seleccione la fecha de ingreso';
                    setFechaVaciaIngreso(true);
                }

                if (fieldName === 'solicitanteIdentidad') {
                    if (fieldValue.length !== 13) {
                        errorMessage = '-La identidad del solicitante debe ser de 13 dígitos';
                    }
                }

                if (selectedDepartamentoSolicitante === null) {
                    errorMessages['solicitanteDepartamento'] = '-Seleccione el departamento del solicitante';
                }

                if (selectedDepartamentoLaboralSolicitante === null) {
                    errorMessages['laboralDepartamento'] = '-Seleccione el departamento laboral del solicitante';
                }

                if (selectedCivilSolicitante === null) {
                    errorMessages['estadocivilSolicitante'] = '-Seleccione el estado civil del solicitante';
                }

                if (tipoPrestamo === "prestamo2") {
                    if (fieldName === 'aval1Identidad') {
                        if (fieldValue.length !== 13) {
                            errorMessage = '-La identidad del Aval 1 debe ser de 13 dígitos';
                        }
                    }

                    if (fieldName === 'aval2Identidad') {
                        if (fieldValue.length !== 13) {
                            errorMessage = '-La identidad del Aval 2 debe ser de 13 dígitos';
                        }
                    }

                    if (tipoViviendaAval1 === 'all') {
                        errorMessages['tipoViviendaAval1'] = '-Seleccione el tipo de vivienda del aval 1.';
                    }

                    if (tipoViviendaAval2 === 'all') {
                        errorMessages['tipoViviendaAval2'] = '-Seleccione el tipo de vivienda del aval 2.';
                    }

                    if (!selectedDateAval1) {
                        errorMessages['aval1nacimiento'] = '-Seleccione la fecha de nacimiento del aval 1';
                        setFechaVacia(true);
                    }

                    if (!selectedDateAval2) {
                        errorMessages['aval2nacimiento'] = '-Seleccione la fecha de nacimiento del aval 2';
                        setFechaVacia(true);
                    }

                    if (selectedDepartamentoAval1 === null) {
                        errorMessages['aval1Departamento'] = '-Seleccione el departamento del aval 1';
                    }

                    if (selectedDepartamentoAval2 === null) {
                        errorMessages['aval2Departamento'] = '-Seleccione el departamento del aval 2';
                    }

                    if (selectedDepartamentoLaboralAval1 === null) {
                        errorMessages['aval1Departamentotrabajo'] = '-Seleccione el departamento laboral del aval 1';
                    }

                    if (selectedDepartamentoLaboralAval2 === null) {
                        errorMessages['aval2Departamentotrabajo'] = '-Seleccione el departamento laboral del aval 2';
                    }

                    if (selectedCivilAval1 === null) {
                        errorMessages['estadocivilAval1'] = '-Seleccione el estado civil del aval 1';
                    }

                    if (selectedCivilAval2 === null) {
                        errorMessages['estadocivilAval2'] = '-Seleccione el estado civil del aval 2';
                    }
                }

                // Validación para los números de teléfono
                if (fieldName === 'solicitanteMovil') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono móvil del solicitante debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'solicitanteFijo') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono fijo del solicitante debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'laboralTelefono') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono laboral del solicitante debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'laboralTelefono') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono laboral del solicitante debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'aval1Movil') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono móvil del aval 1 debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'aval1Fijo') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono fijo del aval 1 debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'aval1TelefonoTrabajo') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono laboral del aval 1 debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'aval2Movil') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono móvil del aval 2 debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'aval2Fijo') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono fijo del aval 2 debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'aval2TelefonoTrabajo') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono laboral del aval 2 debe ser de 8 dígitos';
                    }
                }

                if (selectedBancoCuenta === null) {
                    errorMessages['solicitanteBancoCuenta'] = '-Seleccione el banco de la cuenta del solicitante';
                }

                //Validación detalle de salario y deducciones del solicitante
                if (fieldName === 'cantidadneta') {
                    if (salarioMensual < totalDeducciones) {
                        errorMessage = `-El total de deducciones "L.${totalDeducciones}" es mayor que el salario nominal mensual "L.${salarioMensual}"`;
                    }
                }

                if (fieldName === 'consolidacionparcial1') {
                    if (consolidacionParcial > consolidacionTotal) {
                        errorMessage = `-La consolidación parcial "L.${consolidacionParcial}" es mayor que la consolidación total "L.${consolidacionTotal}"`;
                    }
                }

                // Validación para campos vacíos
                const requiredFieldsAval = {
                    // Página 5: Aval 1
                    aval1Identidad: 'Identidad del Aval 1',
                    aval1Nombres: 'Nombres del Aval 1',
                    aval1Apellidos: 'Apellidos del Aval 1',
                    //aval1Nacimiento: 'Fecha de nacimiento del Aval 1',
                    aval1Profesion: 'Profesión del Aval 1',
                    aval1Barrio: 'Barrio del Aval 1',
                    aval1Ave: 'Avenida del Aval 1',
                    aval1Calle: 'Calle del Aval 1',
                    aval1Casa: 'Número de casa del Aval 1',
                    //estadocivilAval1: 'Estado civil del Aval 1',
                    aval1Ciudad: 'Ciudad del Aval 1',
                    //aval1Departamento: 'Departamento del Aval 1',
                    aval1ReferenciaDomicilio: 'Referencia domiciliaria del Aval 1',
                    aval1Fijo: 'Teléfono fijo del Aval 1',
                    aval1Movil: 'Teléfono móvil del Aval 1',
                    aval1Correo: 'Correo del Aval 1',
                    aval1Dependencia: 'Dependencia laboral del Aval 1',
                    aval1Ramo: 'Ramo laboral del Aval 1',
                    aval1BarrioTrabajo: 'Barrio laboral del Aval 1',
                    aval1AveTrabajo: 'Avenida laboral del Aval 1',
                    aval1TelefonoTrabajo: 'Teléfono laboral del Aval 1',
                    aval1CalleTrabajo: 'Calle laboral del Aval 1',
                    aval1CasaTrabajo: 'Número de casa laboral del Aval 1',
                    aval1CiudadTrabajo: 'Ciudad laboral del Aval 1',
                    sueldoMensualAval1: 'Sueldo mensual del Aval 1',
                    otrosIngresosAval1: 'Otros ingresos del Aval 1',
                    sueldoNetoAval1: 'Sueldo neto del Aval 1',
                    aval1Puesto: 'Puesto laboral del Aval 1',
                    aval1Years: 'Años de experiencia laboral del Aval 1',
                    aval1Meses: 'Meses de experiencia laboral del Aval 1',
                    //aval1Departamentotrabajo: 'Departamento laboral del Aval 1',

                    // Página 6: Aval 2
                    aval2Identidad: 'Identidad del Aval 2',
                    aval2Nombres: 'Nombres del Aval 2',
                    aval2Apellidos: 'Apellidos del Aval 2',
                    //aval2Nacimiento: 'Fecha de nacimiento del Aval 2',
                    aval2Profesion: 'Profesión del Aval 2',
                    aval2Barrio: 'Barrio del Aval 2',
                    aval2Ave: 'Avenida del Aval 2',
                    aval2Calle: 'Calle del Aval 2',
                    aval2Casa: 'Número de casa del Aval 2',
                    //estadocivilAval2: 'Estado civil del Aval 2',
                    aval2Ciudad: 'Ciudad del Aval 2',
                    //aval2Departamento: 'Departamento del Aval 2',
                    aval2ReferenciaDomicilio: 'Referencia domiciliaria del Aval 2',
                    aval2Fijo: 'Teléfono fijo del Aval 2',
                    aval2Movil: 'Teléfono móvil del Aval 2',
                    aval2Correo: 'Correo del Aval 2',
                    aval2Dependencia: 'Dependencia laboral del Aval 2',
                    aval2Ramo: 'Ramo laboral del Aval 2',
                    aval2BarrioTrabajo: 'Barrio laboral del Aval 2',
                    aval2AveTrabajo: 'Avenida laboral del Aval 2',
                    aval2TelefonoTrabajo: 'Teléfono laboral del Aval 2',
                    aval2CalleTrabajo: 'Calle laboral del Aval 2',
                    aval2CasaTrabajo: 'Número de casa laboral del Aval 2',
                    aval2CiudadTrabajo: 'Ciudad laboral del Aval 2',
                    sueldoMensualAval2: 'Sueldo mensual del Aval 2',
                    otrosIngresosAval2: 'Otros ingresos del Aval 2',
                    sueldoNetoAval2: 'Sueldo neto del Aval 2',
                    aval2Puesto: 'Puesto laboral del Aval 2',
                    aval2Years: 'Años de experiencia laboral del Aval 2',
                    aval2Meses: 'Meses de experiencia laboral del Aval 2',
                    //aval2Departamentotrabajo: 'Departamento laboral del Aval 2',
                }

                const requiredFields = {
                    // Página 2: Datos del solicitante
                    solicitanteIdentidad: 'Identidad del solicitante',
                    solicitanteNombres: 'Nombres del solicitante',
                    solicitanteApellidos: 'Apellidos del solicitante',
                    //solicitanteNacimiento: 'Fecha de nacimiento del solicitante',
                    solicitanteProfesion: 'Profesión del solicitante',
                    solicitanteBarrio: 'Barrio del solicitante',
                    solicitanteAve: 'Avenida del solicitante',
                    solicitanteCalle: 'Calle del solicitante',
                    solicitanteCasa: 'Número de casa del solicitante',
                    solicitanteCiudad: 'Ciudad del solicitante',
                    //solicitanteDepartamento: 'Departamento del solicitante',
                    solicitanteCorreo: 'Correo del solicitante',
                    //estadocivilSolicitante: 'Estado civil del solicitante',
                    solicitanteReferenciaDomicilio: 'Referencia domicilio del solicitante',
                    solicitanteFijo: 'Teléfono fijo del solicitante',
                    solicitanteMovil: 'Teléfono móvil del solicitante',

                    // Página 3: Información laboral solicitante
                    laboralDependencia: 'Dependencia laboral del solicitante',
                    laboralRamo: 'Ramo laboral del solicitante',
                    laboralBarrio: 'Barrio laboral del solicitante',
                    laboralAve: 'Avenida laboral del solicitante',
                    laboralCalle: 'Calle laboral del solicitante',
                    laboralCasa: 'Número de casa laboral del solicitante',
                    laboralCiudad: 'Ciudad laboral del solicitante',
                    //laboralDepartamento: 'Departamento laboral del solicitante',
                    laboralTelefono: 'Teléfono laboral del solicitante',
                    sueldoMensualsoli: 'Sueldo mensual del solicitante',
                    otrosIngresossoli: 'Otros ingresos del solicitante',
                    sueldoNetosoli: 'Sueldo neto del solicitante',
                    laboralPuesto: 'Puesto laboral del solicitante',
                    laboralYears: 'Años de experiencia laboral del solicitante',
                    laboralMeses: 'Meses de experiencia laboral del solicitante',
                    //tipoVivienda: 'Tipo de vivienda del solicitante',

                    // Página 4: Referencias Personales
                    referencia1Nombres: 'Nombres de la referencia personal 1',
                    referencia1Parentesco: 'Parentesco de la referencia personal 1',
                    referencia1Direccion: 'Dirección de la referencia personal 1',
                    referencia1Telefono: 'Teléfono de la referencia personal 1',
                    referencia2Nombres: 'Nombres de la referencia personal 2',
                    referencia2Parentesco: 'Parentesco de la referencia personal 2',
                    referencia2Direccion: 'Dirección de la referencia personal 2',
                    referencia2Telefono: 'Teléfono de la referencia personal 2',

                    // Página 7: Transferencia de pago
                    //solicitanteBancoCuenta: 'Nombre del banco',
                    nocuenta: 'Número de cuenta bancaria',

                    // Página 9: Detalles financieros
                    rrhhSalarioMensual: 'Salario nominal mensual',
                    ihss: 'IHSS',
                    isr: 'ISR',
                    prestamoconinjupemp: 'Préstamo con Injupemp',
                    pensionjubilacion: 'Pensión o jubilación',
                    embargos: 'Embargos',
                    otrodetalle1: 'Otro detalle 1',
                    otrodetalle2: 'Otro detalle 2',
                    otrodetalle3: 'Otro detalle 3',
                    otrodetalle4: 'Otro detalle 4',
                    otrodetalle5: 'Otro detalle 5',
                    otrodetalle6: 'Otro detalle 6',
                    otrodetalle7: 'Otro detalle 7'
                };

                for (const [fieldName, fieldLabel] of Object.entries(requiredFields)) {
                    if (!formulario[fieldName]) {
                        errorMessages[fieldName] = `El campo "${fieldLabel}" es obligatorio.`;
                    }
                }

                if (tipoPrestamo === "prestamo2") {
                    for (const [fieldName, fieldLabel] of Object.entries(requiredFieldsAval)) {
                        if (!formulario[fieldName]) {
                            errorMessages[fieldName] = `El campo "${fieldLabel}" es obligatorio.`;
                        }
                    }
                }
                errorMessages[fieldName] = errorMessage;
            });
        }

        // Actualizar el estado de los errores
        setErrors(errorMessages);

        // Verificar si hay errores después de ejecutar la validación
        const hasErrors = Object.values(errorMessages).some(error => error !== '');
        if (hasErrors) {
            setOpenDialogErrores(true);
        } else {
            handleOpen(true);
        }
    };

    const handleLempirasBlur = (event, rowIndex) => {
        let lempirasValue = event.target.value;
        if (lempirasValue === '') {
            lempirasValue = 0;
        }

        let dolaresValue = document.getElementById(`dolaresconsolidar${rowIndex}`).value;
        if (dolaresValue === '') {
            dolaresValue = 0;
        }
        const conversionRate = 24.67; // Tasa de conversión de dólares a lempiras

        // Calcula el Total Lempiras
        const totalLempiras = (parseFloat(dolaresValue) * conversionRate);
        document.getElementById(`total-lempiras-consolidar-${rowIndex}`).value = totalLempiras.toFixed(2);

        // Calcula y actualiza el Total
        const total = parseFloat(lempirasValue) + totalLempiras;
        document.getElementById(`consolidaciontotal${rowIndex}`).value = total.toFixed(2);
        setConsolidacionTotal(total);
    };

    const [open, setOpen] = React.useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogErrores, setOpenDialogErrores] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleCloseDialogErrores = () => {
        setOpenDialogErrores(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    function detalledesalario() {
        return (
            <Container>
                <Box>
                    <h3>XI. DETALLE DE SALARIO Y DEDUCCIONES DEL SOLICITANTE </h3>
                    <Stack direction="column">
                        <Box>
                            <TableContainer component={Paper} style={{ width: 320 }}>
                                <Table aria-label="customized table">
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>
                                                <h3>Para uso exclusivo de Recursos Humanos</h3>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <CustomDatePickerIngreso label="Fecha Ingreso" id="rrhhingreso" />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField
                                                    id="rrhhSalarioMensual"
                                                    value={formulario.rrhhSalarioMensual}
                                                    onChange={handleChange}
                                                    placeholder="Salario Nominal Mensual"
                                                    label="Salario Nominal Mensual"
                                                    variant="outlined"
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setSalarioMensual(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario}
                                                    InputProps={{
                                                        startAdornment: (<InputAdornment position="start">L.</InputAdornment>),
                                                    }}
                                                />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField
                                                    id="ihss"
                                                    value={formulario.ihss}
                                                    onChange={handleChange}
                                                    placeholder="I.H.S.S."
                                                    label="I.H.S.S."
                                                    variant="outlined"
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setIhss(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario}
                                                    InputProps={{
                                                        startAdornment: (<InputAdornment position="start">L.</InputAdornment>),
                                                    }}
                                                />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField
                                                    id="isr"
                                                    value={formulario.isr}
                                                    onChange={handleChange}
                                                    placeholder="I.S.R."
                                                    label="I.S.R."
                                                    variant="outlined"
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setIsr(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario}
                                                    InputProps={{
                                                        startAdornment: (<InputAdornment position="start">L.</InputAdornment>),
                                                    }}
                                                />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField
                                                    id="prestamoconinjupemp"
                                                    value={formulario.prestamoconinjupemp}
                                                    onChange={handleChange}
                                                    placeholder="Préstamo Personal Con INJUPEMP"
                                                    label="Préstamo personal con INJUPEMP"
                                                    variant="outlined"
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setPrestamoInjupemp(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario}
                                                    InputProps={{
                                                        startAdornment: (<InputAdornment position="start">L.</InputAdornment>),
                                                    }}
                                                />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField
                                                    id="pensionjubilacion"
                                                    value={formulario.pensionjubilacion}
                                                    onChange={handleChange}
                                                    label="Pensión y Jubilación"
                                                    placeholder="Pensión Y Jubilación"
                                                    variant="outlined"
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setPensionJubilacion(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario}
                                                    InputProps={{
                                                        startAdornment: (<InputAdornment position="start">L.</InputAdornment>),
                                                    }}
                                                />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField
                                                    id="embargos"
                                                    value={formulario.embargos}
                                                    onChange={handleChange}
                                                    placeholder="Embargos"
                                                    label="Embargos"
                                                    variant="outlined"
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setEmbargos(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario}
                                                    InputProps={{
                                                        startAdornment: (<InputAdornment position="start">L.</InputAdornment>),
                                                    }}
                                                />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField id="otrodetalle1" label="Otro (detalle):" variant="outlined"
                                                    value={formulario.otrodetalle1}
                                                    onChange={handleChange}
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setOtrosIngresos1(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario}
                                                />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField id="otrodetalle2" label="Otro (detalle):" variant="outlined"
                                                    value={formulario.otrodetalle2}
                                                    onChange={handleChange}
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setOtrosIngresos2(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario} />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField id="otrodetalle3" label="Otro (detalle):" variant="outlined"
                                                    value={formulario.otrodetalle3}
                                                    onChange={handleChange}
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setOtrosIngresos3(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario} />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField id="otrodetalle4" label="Otro (detalle):" variant="outlined"
                                                    value={formulario.otrodetalle4}
                                                    onChange={handleChange}
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setOtrosIngresos4(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario} />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField id="otrodetalle5" label="Otro (detalle):" variant="outlined"
                                                    value={formulario.otrodetalle5}
                                                    onChange={handleChange}
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setOtrosIngresos5(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario} />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField id="otrodetalle6" label="Otro (detalle):" variant="outlined"
                                                    value={formulario.otrodetalle6}
                                                    onChange={handleChange}
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setOtrosIngresos6(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario} />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField id="otrodetalle7" label="Otro (detalle):" variant="outlined"
                                                    value={formulario.otrodetalle7}
                                                    onChange={handleChange}
                                                    onInput={(event) => {
                                                        validarSoloNumeros(event);
                                                        setOtrosIngresos7(parseInt(event.target.value) || 0);
                                                    }}
                                                    onBlur={handleBlurSalario} />
                                            </FormControl>
                                        </TableRow>
                                        <TableRow>
                                            <Divider></Divider>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField
                                                    id="totaldeducciones"
                                                    label="TOTAL DEDUCCIONES:"
                                                    variant="outlined"
                                                    value={totalDeducciones}
                                                    InputProps={{
                                                        readOnly: true,
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                L.
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </FormControl>
                                        </TableRow>

                                        <TableRow>
                                            <Divider></Divider>
                                            <FormControl sx={{ m: 1, width: 300, marginTop: 2 }}>
                                                <TextField
                                                    id="cantidadneta"
                                                    label="CANTIDAD NETA QUE PERCIBE AL MES:"
                                                    variant="outlined"
                                                    value={cantidadNeta}
                                                    InputProps={{
                                                        readOnly: true,
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                L.
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </FormControl>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Stack>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '20vh', // Establece la altura de la caja para ocupar toda la pantalla verticalmente
                    }}
                >
                    <Grid item>
                        <Button
                            onClick={validateErrors}
                            endIcon={<SendIcon />}
                            variant="contained"
                            color="success"
                            size="large"
                        >
                            <span>Enviar</span>
                        </Button>
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={open}
                            onClick={handleClose}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </Grid>
                    <Dialog open={openDialog} onClose={handleCloseDialog}>
                        <DialogTitle>{"Enviado"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description" align='justify'>
                                Los datos fueron enviados con éxito.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDialog} variant='contained' startIcon={< CheckCircleOutlineIcon />} color="success">
                                Aceptar
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog open={openDialogErrores} onClose={handleCloseDialogErrores}>
                        <DialogTitle>
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <ReportProblemIcon style={{ marginRight: '5px', color: 'var(--color-brand-secondary)' }} />
                                Error de Validación
                                <ReportProblemIcon style={{ marginLeft: '5px', color: 'var(--color-brand-secondary)' }} />
                            </span>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Hay errores en el formulario. Por favor, corríjalos antes de enviar.
                            </DialogContentText>
                            <Divider></Divider>
                            <ul>
                                {Object.entries(errors).map(([fieldName, errorMessage]) => (
                                    <li key={fieldName}>{errorMessage}</li>
                                ))}
                            </ul>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDialogErrores} variant='contained' startIcon={< CheckCircleOutlineIcon />} color="success">
                                Aceptar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            </Container>
        )
    }

    function deudasaconsolidar() {
        return (
            <Box>
                <Stack direction="column">
                    <Grid>
                        <Stack>
                            <h3>X. DEUDAS A CONSOLIDAR</h3>
                        </Stack>
                        <Box>
                            <TableContainer component={Paper}>
                                <Table aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ width: 100 }} rowSpan={2} align="center">Institución Financiera</StyledTableCell>
                                            <TableCell colSpan={3} align="center"> Monto</TableCell>
                                            <StyledTableCell colSpan={2} align="center">Consolidación</StyledTableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="center" sx={{ m: 1, width: 150 }}>Lempiras</TableCell>
                                            <TableCell align="center" sx={{ m: 1, width: 150 }}>Dólares</TableCell>
                                            <TableCell align="center" sx={{ m: 1, width: 150 }}>Total Lempiras</TableCell>
                                            <StyledTableCell align="center" sx={{ m: 1, width: 150 }}>Total</StyledTableCell>
                                            <StyledTableCell align="center" sx={{ m: 1, width: 150 }}>Parcial</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {[1, 2, 3, 4, 5].map((row) => (
                                            <TableRow key={row}>
                                                <StyledTableCell component="th" scope="row">
                                                    <Box sx={{ m: 1, width: 300 }}>
                                                        <Autocomplete
                                                            id={`solicitanteBancoCuentaConsolidar${row}`}
                                                            {...defaultPropsBancos}
                                                            renderInput={(params) => (
                                                                <TextField {...params} id={`solicitanteBancoCuentaConsolidar${row}`} label="Nombre del Banco" variant="outlined"
                                                                    error={Boolean(errors[`solicitanteBancoCuentaConsolidar${row}`])}
                                                                    onBlur={handleBlur}
                                                                    helperText={errors[`solicitanteBancoCuentaConsolidar${row}`]} />)}
                                                        />
                                                    </Box>
                                                </StyledTableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`lempirasconsolidar${row}`}
                                                            variant="outlined"
                                                            onInput={(event) => {
                                                                validarSoloNumeros(event);
                                                            }}
                                                            onBlur={(event) => {
                                                                handleLempirasBlur(event, row);
                                                                handleBlur(event);
                                                            }}
                                                            error={Boolean(errors[`lempirasconsolidar${row}`])}
                                                            helperText={errors[`lempirasconsolidar${row}`]}
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">L.</InputAdornment>,
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`dolaresconsolidar${row}`}
                                                            variant="outlined"
                                                            onInput={(event) => {
                                                                validarSoloNumeros(event);
                                                            }}
                                                            onBlur={(event) => {
                                                                handleLempirasBlur(event, row);
                                                                handleBlur(event);
                                                            }}
                                                            error={Boolean(errors[`dolaresconsolidar${row}`])}
                                                            helperText={errors[`dolaresconsolidar${row}`]}
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">$.</InputAdornment>,
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`total-lempiras-consolidar-${row}`}
                                                            variant="outlined"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`consolidaciontotal${row}`}
                                                            variant="outlined"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`consolidacionparcial${row}`}
                                                            variant="outlined"
                                                            onInput={(event) => {
                                                                validarSoloNumeros(event);
                                                                setConsolidacionParcial(parseInt(event.target.value) || 0);
                                                            }}
                                                            onBlur={(event) => {
                                                                handleBlur(event);
                                                            }}
                                                            error={Boolean(errors[`consolidacionparcial${row}`])}
                                                            helperText={errors[`consolidacionparcial${row}`]}
                                                            InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Grid>
                </Stack>
            </Box>
        )
    }

    const renderContent = () => {
        if (currentPage === 1) {
            return (
                <Container>
                    <Stack direction="column" sx={{ justifyContent: 'center', alignItems: 'center' }}>
                        <Grid spacing={2} container sx={{ justifyContent: 'center' }}>
                            <Grid style={{ textAlign: 'center', alignItems: 'center' }}>
                                <h3>DPP-F-04.2</h3>
                                <h1>SOLICITUD DE PRÉSTAMO</h1>
                            </Grid>
                        </Grid>
                    </Stack>

                    <Stack direction="column" spacing={2}>
                        <TextField id="NoSolicitud" variant="outlined" label='No. Solicitud' />
                        <TextField id="NoCotizante" variant="outlined" label='No. Cotizante' />
                    </Stack>

                    <Stack direction="column" marginTop={2} style={{ textAlign: 'center' }}>
                        {<label><strong>TIPO DE PRÉSTAMO</strong></label>}
                    </Stack>

                    <Stack direction="column" marginTop={2}>
                        <Grid spacing={2} container>
                            <FormControl>
                                <RadioGroup
                                    id="grupoTipoPrestamo"
                                    value={tipoPrestamo}
                                    onChange={handleTipoPrestamo}
                                    column
                                    aria-labelledby="Tipo Prestamo"
                                    name="tipoPrestamo"
                                >
                                    <FormControlLabel value="prestamo1" control={<Radio color="error" variant="solid" />} label="Sin Aval" />
                                    <FormControlLabel value="prestamo2" control={<Radio color="error" />} label="Con Aval" />
                                    <FormControlLabel value="prestamo3" control={<Radio color="error" />} label="Consolidacion de Deuda" />
                                    <FormControlLabel value="prestamo4" control={<Radio color="error" />} label="Alivio de Deuda" />
                                    <FormControlLabel value="prestamo5" control={<Radio color="error" />} label="Refinanciamiento" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Stack>
                </Container>
            );
        } else if (currentPage === 2) {
            return (
                <Container>
                    <Box>
                        <Stack direction="column" sx={{ justifyContent: 'center', alignItems: 'center' }}>
                            <h3 >I. DATOS DEL SOLICITANTE</h3>
                        </Stack>

                        <Stack direction="column" spacing={2}>
                            <TextField
                                id="solicitanteIdentidad"
                                label="Número de Identidad"
                                placeholder="Ingrese # de identidad"
                                variant="outlined"
                                value={formulario.solicitanteIdentidad}
                                onChange={handleChange}
                                //value={formData.solicitanteIdentidad}
                                //onChange={handleChangeValor}
                                onInput={validarSoloNumeros}
                                inputProps={{ maxLength: 13 }} // Limitar la longitud máxima a 13 caracteres
                                error={Boolean(errors.solicitanteIdentidad)}
                                onBlur={handleBlur}
                                helperText={errors.solicitanteIdentidad}
                            />
                            <TextField
                                id="solicitanteNombres"
                                label="Nombres"
                                placeholder="Ingrese el nombre"
                                variant="outlined"
                                value={formulario.solicitanteNombres}
                                onChange={handleChange}
                                onInput={validarSoloLetras}
                                error={Boolean(errors.solicitanteNombres)}
                                onBlur={handleBlur}
                                helperText={errors.solicitanteNombres}
                            />
                            <TextField
                                id="solicitanteApellidos"
                                label="Apellidos"
                                placeholder="Ingrese los apellidos"
                                variant="outlined"
                                value={formulario.solicitanteApellidos}
                                onChange={handleChange}
                                onInput={validarSoloLetras}
                                error={Boolean(errors.solicitanteApellidos)}
                                onBlur={handleBlur}
                                helperText={errors.solicitanteApellidos}
                            />
                            <CustomDatePickerNacimiento id='solicitanteNacimiento' label="Fecha Nacimiento" />
                            <TextField
                                id="solicitanteProfesion"
                                label="Profesión u Oficio"
                                placeholder="Ingrese la profesión u oficio"
                                variant="outlined"
                                value={formulario.solicitanteProfesion}
                                onChange={handleChange}
                                onInput={validarSoloLetras}
                                error={Boolean(errors.solicitanteProfesion)}
                                onBlur={handleBlur}
                                helperText={errors.solicitanteProfesion}
                            />
                        </Stack>

                        <Stack className={classes.above} direction="column" marginTop={2}>
                            <Grid spacing={2} container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                                <Box >
                                    <FormControl >
                                        <Stack direction="column" marginTop={2} style={{ textAlign: 'center' }}>
                                            {<label><strong>Tipo De Vivienda</strong></label>}
                                        </Stack>
                                        <RadioGroup row aria-labelledby="Tipo Vivienda" name="tipoVivienda"
                                            onChange={handleTipoVivienda} value={tipoVivienda}>
                                            <FormControlLabel value="vivienda1" control={<Radio color="error" />} label="Propia" />
                                            <FormControlLabel value="vivienda2" control={<Radio color="error" />} label="Familiar" />
                                            <FormControlLabel value="vivienda3" control={<Radio color="error" />} label="Alquilada" />
                                        </RadioGroup>
                                    </FormControl>
                                </Box>
                            </Grid>
                        </Stack>

                        <Stack className={classes.above} direction="column" marginTop={2}>
                            <Grid Container>
                                <label style={{ display: 'flex', justifyContent: 'center' }}><strong>Dirección</strong></label>

                                <Stack direction="column" spacing={2}>
                                    <TextField id="solicitanteBarrio" label="Barrio/Col." variant="outlined" placeholder="Ingrese barrio o colonia"
                                        value={formulario.solicitanteBarrio}
                                        onChange={handleChange}
                                        error={Boolean(errors.solicitanteBarrio)}
                                        onBlur={handleBlur}
                                        helperText={errors.solicitanteBarrio} />

                                    <TextField id="solicitanteAve" label="Ave." variant="outlined" placeholder="Ingrese avenida"
                                        value={formulario.solicitanteAve}
                                        onChange={handleChange}
                                        error={Boolean(errors.solicitanteAve)}
                                        onBlur={handleBlur}
                                        helperText={errors.solicitanteAve} />

                                    <TextField id="solicitanteCalle" label="Calle" variant="outlined" placeholder="Ingrese calle"
                                        value={formulario.solicitanteCalle}
                                        onChange={handleChange}
                                        error={Boolean(errors.solicitanteCalle)}
                                        onBlur={handleBlur}
                                        helperText={errors.solicitanteCalle} />

                                    <TextField id="solicitanteCasa" label="Casa No." placeholder="Ingrese # de casa" variant="outlined" onInput={validarSoloNumeros}
                                        value={formulario.solicitanteCasa}
                                        onChange={handleChange}
                                        error={Boolean(errors.solicitanteCasa)}
                                        onBlur={handleBlur}
                                        helperText={errors.solicitanteCasa} />

                                    <TextField id="solicitanteCiudad" label="Ciudad" placeholder="Ingrese la ciudad" variant="outlined"
                                        value={formulario.solicitanteCiudad}
                                        onChange={handleChange}
                                        error={Boolean(errors.solicitanteCiudad)}
                                        onBlur={handleBlur}
                                        helperText={errors.solicitanteCiudad} />

                                    <Autocomplete
                                        id="solicitanteDepartamento"
                                        {...defaultProps}
                                        value={selectedDepartamentoSolicitante}
                                        onChange={handleDepartamentoChange}
                                        renderInput={(params) => (
                                            <TextField {...params}
                                                id="solicitanteDepartamento" placeholder="Ingrese el departamento" label="Departamento" variant="outlined"
                                                error={Boolean(errors.solicitanteDepartamento)}
                                                onBlur={handleBlur}
                                                helperText={errors.solicitanteDepartamento} />
                                        )}

                                    />
                                    <Autocomplete
                                        {...defaultPropsCivil}
                                        id="estadocivilSolicitante"
                                        value={selectedCivilSolicitante}
                                        onChange={handleCivilChange}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Estado Civil" value={formulario.estadocivilSolicitante}
                                                onChange={handleChange} variant="outlined" placeholder="Ingrese el estado civil"
                                                error={Boolean(errors.estadocivilSolicitante)}
                                                onBlur={handleBlur}
                                                helperText={errors.estadocivilSolicitante} />
                                        )}
                                    />
                                    <TextField id="solicitanteReferenciaDomicilio" value={formulario.solicitanteReferenciaDomicilio}
                                        onChange={handleChange} label="Referencia Domicilio" variant="outlined" placeholder="Ingrese la referencia del domicilio"
                                        error={Boolean(errors.solicitanteReferenciaDomicilio)}
                                        onBlur={handleBlur}
                                        helperText={errors.solicitanteReferenciaDomicilio} />
                                    <TextField id="solicitanteFijo" label="Teléfono Fijo" placeholder="Ingrese el teléfono fijo" variant="outlined" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                        value={formulario.solicitanteFijo}
                                        onChange={handleChange}
                                        error={Boolean(errors.solicitanteFijo)}
                                        onBlur={handleBlur}
                                        helperText={errors.solicitanteFijo} />
                                    <TextField id="solicitanteMovil" label="Teléfono Móvil" placeholder="Ingrese el teléfono móvil" variant="outlined" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                        value={formulario.solicitanteMovil}
                                        onChange={handleChange}
                                        error={Boolean(errors.solicitanteMovil)}
                                        onBlur={handleBlur}
                                        helperText={errors.solicitanteMovil} />
                                    <TextField id="solicitanteCorreo" label="Correo Electrónico" placeholder="Ingrese el correo electrónico" variant="outlined"
                                        value={formulario.solicitanteCorreo}
                                        onChange={handleChange}
                                        error={Boolean(errors.solicitanteCorreo)}
                                        onBlur={handleBlur}
                                        helperText={errors.solicitanteCorreo} />
                                </Stack>

                                <Box marginTop={5}>
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <h3>COPIA DE LA IDENTIDAD EN FORMATO PDF</h3>
                                        </Box>
                                    </Box>
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        onDragOver={handleDragOverIdentidadSoli}
                                        onDrop={handleDropIdentidadSoli}
                                    >
                                        <Box
                                            style={{
                                                padding: '50px',
                                                width: '300px',
                                                textAlign: 'center',
                                                borderColor: selectedIdentidadSoli ? 'green' : '#a0a0a0',
                                                borderRadius: 5,
                                                borderWidth: 5,
                                                borderStyle: 'dashed',
                                            }}
                                        >
                                            <Tooltip
                                                title={
                                                    <div style={{ textAlign: 'center' }}>
                                                        <p style={{ fontSize: 15, textAlign: 'justify' }}>El archivo pdf debe contener la tarjeta de identidad por ambos lados de la siguiente forma:</p>
                                                        <img src={IdentidadEjemplo} alt="Identidad Ejemplo" style={{ width: '200px', height: 'auto' }} />
                                                    </div>
                                                }
                                                interactive
                                            >
                                                <CloudUploadIcon style={{ fontSize: 48, color: 'gray' }} />
                                            </Tooltip>
                                            <br />
                                            <Button
                                                variant="contained"
                                                onClick={handleClickIdentidadSoli}
                                                style={{ marginTop: '10px', backgroundColor: '#ECECEC' }}
                                            >
                                                Seleccionar Identidad En PDF
                                            </Button>
                                            <input
                                                id="selectedIdentidadSoli"
                                                type="file"
                                                accept=".pdf"
                                                style={{ display: 'none' }}
                                                onChange={handleFileChangeIdentidadSoli}
                                            />
                                            {!selectedIdentidadSoli && <p>Seleccione el archivo PDF</p>}
                                            {selectedIdentidadSoli && <p>Archivo seleccionado: {selectedIdentidadSoli.name}</p>}
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        </Stack>
                    </Box>
                </Container>
            )
        } else if (currentPage === 3) {
            return (
                <Container>
                    <Box>
                        <Stack direction="column">
                            <h3 >II. INFORMACIÓN LABORAL (participantes activos)</h3>
                        </Stack>

                        <Stack direction="column" spacing={2}>
                            <TextField id="laboralDependencia" label="Dependencia donde Trabaja" variant="outlined" placeholder="Ingrese dependencia laboral"
                                value={formulario.laboralDependencia}
                                onChange={handleChange}
                                error={Boolean(errors.laboralDependencia)}
                                onBlur={handleBlur}
                                helperText={errors.laboralDependencia} />
                            <TextField id="laboralRamo" label="Ramo" variant="outlined" placeholder="Ingrese el ramo"
                                value={formulario.laboralRamo}
                                onChange={handleChange}
                                error={Boolean(errors.laboralRamo)}
                                onBlur={handleBlur}
                                helperText={errors.laboralRamo} />
                            <TextField id="laboralTelefono" placeholder="Ingrese el teléfono" label="Teléfono" variant="outlined" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                value={formulario.laboralTelefono}
                                onChange={handleChange}
                                error={Boolean(errors.laboralTelefono)}
                                onBlur={handleBlur}
                                helperText={errors.laboralTelefono} />
                            <label><strong>Dirección</strong></label>
                            <Stack direction="column" spacing={2}>
                                <TextField id="laboralBarrio" label="Barrio/Col." variant="outlined" placeholder="Ingrese el barrio/colonia"
                                    value={formulario.laboralBarrio}
                                    onChange={handleChange}
                                    error={Boolean(errors.laboralBarrio)}
                                    onBlur={handleBlur}
                                    helperText={errors.laboralBarrio} />

                                <TextField id="laboralAve" label="Ave." variant="outlined" placeholder="Ingrese Avenida"
                                    value={formulario.laboralAve}
                                    onChange={handleChange}
                                    error={Boolean(errors.laboralAve)}
                                    onBlur={handleBlur}
                                    helperText={errors.laboralAve} />

                                <TextField id="laboralCalle" label="Calle" variant="outlined" placeholder="Ingrese # Calle"
                                    value={formulario.laboralCalle}
                                    onChange={handleChange}
                                    error={Boolean(errors.laboralCalle)}
                                    onBlur={handleBlur}
                                    helperText={errors.laboralCalle} />

                                <TextField id="laboralCasa" label="Casa No." variant="outlined" placeholder="Ingrese # Casa"
                                    value={formulario.laboralCasa}
                                    onChange={handleChange}
                                    error={Boolean(errors.laboralCasa)}
                                    onBlur={handleBlur}
                                    helperText={errors.laboralCasa} />

                                <TextField id="laboralCiudad" label="Ciudad" variant="outlined" placeholder="Ingrese la ciudad"
                                    value={formulario.laboralCiudad}
                                    onChange={handleChange}
                                    error={Boolean(errors.laboralCiudad)}
                                    onBlur={handleBlur}
                                    helperText={errors.laboralCiudad} />

                                <Autocomplete
                                    {...defaultProps}
                                    id="laboralDepartamento"
                                    value={selectedDepartamentoLaboralSolicitante}
                                    onChange={handleDepartamentoLaboralChange}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Departamento" variant="outlined" placeholder="Ingrese el departamento"
                                            value={formulario.laboralDepartamento}
                                            onChange={handleChange}
                                            error={Boolean(errors.laboralDepartamento)}
                                            onBlur={handleBlur}
                                            helperText={errors.laboralDepartamento} />
                                    )}
                                />
                            </Stack>
                            <TextField id="sueldoMensualsoli" value={formulario.sueldoMensualsoli}
                                onChange={handleChange} placeholder="Ingrese sueldo mensual" label="Sueldo Mensual" variant="outlined" onInput={validarSoloNumeros} InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            L.
                                        </InputAdornment>
                                    ),
                                }}
                                error={Boolean(errors.sueldoMensualsoli)}
                                onBlur={handleBlur}
                                helperText={errors.sueldoMensualsoli} />
                            <TextField id="otrosIngresossoli" onInput={validarSoloNumeros} placeholder="Otros Ingresos" label="Otros Ingresos (detalle)" variant="outlined" InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        L.
                                    </InputAdornment>
                                ),
                            }}
                                value={formulario.otrosIngresossoli}
                                onChange={handleChange}
                                error={Boolean(errors.otrosIngresossoli)}
                                onBlur={handleBlur}
                                helperText={errors.otrosIngresossoli} />
                            <TextField id="sueldoNetosoli" onInput={validarSoloNumeros} placeholder="Ingrese sueldo neto" label="Sueldo Neto" variant="outlined" InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        L.
                                    </InputAdornment>
                                ),
                            }}
                                value={formulario.sueldoNetosoli}
                                onChange={handleChange}
                                error={Boolean(errors.sueldoNetosoli)}
                                onBlur={handleBlur}
                                helperText={errors.sueldoNetosoli} />
                            <TextField id="laboralPuesto" label="Puesto" variant="outlined" placeholder="Ingrese el puesto"
                                value={formulario.laboralPuesto}
                                onChange={handleChange}
                                error={Boolean(errors.laboralPuesto)}
                                onBlur={handleBlur}
                                helperText={errors.laboralPuesto} />
                            <Box>
                                <label><strong>Tiempo De Laborar</strong></label>
                            </Box>
                            <TextField id="laboralYears" label="Años" variant="outlined" placeholder="Años"
                                value={formulario.laboralYears}
                                onChange={handleChange}
                                error={Boolean(errors.laboralYears)}
                                onBlur={handleBlur}
                                helperText={errors.laboralYears} />

                            <TextField id="laboralMeses" label="Meses" variant="outlined" placeholder="Meses"
                                value={formulario.laboralMeses}
                                onChange={handleChange}
                                error={Boolean(errors.laboralMeses)}
                                onBlur={handleBlur}
                                helperText={errors.laboralMeses} />
                        </Stack>
                    </Box>
                </Container>
            )
        } else if (currentPage === 4) {
            return (
                <Container>
                    <Box>
                        <Stack direction="column" style={{ textAlign: 'center' }} >
                            <h3 >III. REFERENCIAS PERSONALES</h3>
                        </Stack>
                        <Stack direction="column" style={{ textAlign: 'center' }}>
                            {<label><strong>Referencia Personal #1</strong></label>}
                        </Stack>
                        <Stack direction="column" spacing={2} marginTop={2}>
                            <TextField id={`referencia1Nombres`} label="Nombre Referencia Personal #1" variant="outlined" onInput={validarSoloLetras} placeholder="Ingrese el nombre completo"
                                value={formulario.referencia1Nombres}
                                onChange={handleChange}
                                error={Boolean(errors[`referencia1Nombres`])}
                                onBlur={handleBlur}
                                helperText={errors[`referencia1Nombres`]} />
                            <TextField id={`referencia1Parentesco`} label="Parentesco Referencia Personal #1" variant="outlined" onInput={validarSoloLetras} placeholder="Ingrese el parentesco"
                                value={formulario.referencia1Parentesco}
                                onChange={handleChange}
                                error={Boolean(errors[`referencia1Parentesco`])}
                                onBlur={handleBlur}
                                helperText={errors[`referencia1Parentesco`]} />
                            <TextField id={`referencia1Direccion`} label="Dirección Referencia Personal #1" variant="outlined" placeholder="Ingrese la dirección"
                                value={formulario.referencia1Direccion}
                                onChange={handleChange}
                                error={Boolean(errors[`referencia1Direccion`])}
                                onBlur={handleBlur}
                                helperText={errors[`referencia1Direccion`]} />
                            <TextField id={`referencia1Telefono`} label="Teléfono Referencia Personal #1" placeholder="Ingrese el teléfono" variant="outlined" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                value={formulario.referencia1Telefono}
                                onChange={handleChange}
                                error={Boolean(errors[`referencia1Telefono`])}
                                onBlur={handleBlur}
                                helperText={errors[`referencia1Telefono`]} />
                        </Stack>
                        <Stack direction="column" style={{ textAlign: 'center' }} marginTop={2}>
                            {<label><strong>Referencia Personal #2</strong></label>}
                        </Stack>
                        <Stack direction="column" spacing={2} marginTop={2}>
                            <TextField id={`referencia2Nombres`} label="Nombre Referencia Personal #2" variant="outlined" onInput={validarSoloLetras} placeholder="Ingrese el nombre completo"
                                value={formulario.referencia2Nombres}
                                onChange={handleChange}
                                error={Boolean(errors[`referencia2Nombres`])}
                                onBlur={handleBlur}
                                helperText={errors[`referencia2Nombres`]} />
                            <TextField id={`referencia2Parentesco`} label="Parentesco Referencia Personal #2" variant="outlined" onInput={validarSoloLetras} placeholder="Ingrese el parentesco"
                                value={formulario.referencia2Parentesco}
                                onChange={handleChange}
                                error={Boolean(errors[`referencia2Parentesco`])}
                                onBlur={handleBlur}
                                helperText={errors[`referencia2Parentesco`]} />
                            <TextField id={`referencia2Direccion`} label="Dirección Referencia Personal #2" variant="outlined" placeholder="Ingrese la dirección"
                                value={formulario.referencia2Direccion}
                                onChange={handleChange}
                                error={Boolean(errors[`referencia2Direccion`])}
                                onBlur={handleBlur}
                                helperText={errors[`referencia2Direccion`]} />
                            <TextField id={`referencia2Telefono`} label="Teléfono Referencia Personal #2" placeholder="Ingrese el teléfono" variant="outlined" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                value={formulario.referencia2Telefono}
                                onChange={handleChange}
                                error={Boolean(errors[`referencia2Telefono`])}
                                onBlur={handleBlur}
                                helperText={errors[`referencia2Telefono`]} />
                        </Stack>
                    </Box>
                </Container>
            )
        } else if (currentPage === 5) {
            if (tipoPrestamo === "prestamo2" || tipoPrestamo === "all") {
                return (
                    <>
                        <Aval
                            errorsEnviar={errors}
                            setErrors={setErrors}
                            formulario={formulario}
                            onchange={handleChange}
                            Datepickernacimiento={CustomDatePickerNacimiento1}
                            handleblurAval={handleBlur}
                            handletipovivienda={handleTipoViviendaAval1}
                            valorvivienda={tipoViviendaAval1}
                            selectedcivil={selectedCivilAval1}
                            handlecivil={handleCivilAval1Change}
                            selecteddepa={selectedDepartamentoAval1}
                            handledepa={handleDepartamentoAval1Change}
                            selecteddepalaboral={selectedDepartamentoLaboralAval1}
                            handledepalaboral={handleDepartamentoLaboralAval1Change}
                        />
                        <Divider />
                    </>
                )
            } else {
                return (
                    transferenciadepago()
                )
            }
        } else if (currentPage === 6) {
            if (tipoPrestamo === "prestamo2" || tipoPrestamo === "all") {
                return (
                    (tipoPrestamo === "prestamo2" || tipoPrestamo === "all") && <>
                        <Aval2
                            errorsEnviar={errors}
                            setErrors={setErrors}
                            formulario={formulario}
                            onchange={handleChange}
                            Datepickernacimiento={CustomDatePickerNacimiento2}
                            handleblurAval={handleBlur}
                            handletipovivienda={handleTipoViviendaAval2}
                            valorvivienda={tipoViviendaAval2}
                            selectedcivil={selectedCivilAval2}
                            handlecivil={handleCivilAval2Change}
                            selecteddepa={selectedDepartamentoAval2}
                            handledepa={handleDepartamentoAval2Change}
                            selecteddepalaboral={selectedDepartamentoLaboralAval2}
                            handledepalaboral={handleDepartamentoLaboralAval2Change}
                        />
                        <Divider />
                    </>
                )
            } else {
                return (
                    deudasaconsolidar()
                )
            }
        } else if (currentPage === 7) {
            if (tipoPrestamo === 'prestamo2' || tipoPrestamo === 'all') {
                return (transferenciadepago())
            } else {
                return (detalledesalario())
            }
        } else if (currentPage === 8) {
            return deudasaconsolidar()
        } else if (currentPage === 9) {
            return detalledesalario()
        }
    };

    return (
        <>
            {renderContent()}

            <Stack direction="row" justifyContent="center" marginTop={3}>
                <Pagination
                    count={numeroPaginas} // Número total de páginas
                    page={currentPage}
                    siblingCount={0}
                    onChange={handlePageChange}
                    color="standard"
                    size="large"
                />
            </Stack>
        </>
    );
}
const listadepartamentos = [
    { title: 'Atlantida', },
    { title: 'Colón', },
    { title: 'Comayagua', },
    { title: 'Copán', },
    { title: 'Cortés', },
    { title: 'Choluteca', },
    { title: 'El Paraíso', },
    { title: 'Francisco Morazán', },
    { title: 'Gracias A Dios', },
    { title: 'Intibucá', },
    { title: 'Islas De La Bahía', },
    { title: 'La Paz', },
    { title: 'Lempira', },
    { title: 'Ocotepeque', },
    { title: 'Olancho', },
    { title: 'Santa Bárbara', },
    { title: 'Valle', },
    { title: 'Yoro', },
];

const listacivil = [
    { title: 'Soltero', },
    { title: 'Casado', },
    { title: 'Viudo', },
    { title: 'Divorciado', },
    { title: 'Unión Libre', },
];

const listabancos = [
    { title: 'Banco Atlántida S.A.', },
    { title: 'Banco de Occidente S.A.', },
    { title: 'Banco de Los Trabajadores', },
    { title: 'Banco Financiera Centroamericana S.A. (FICENSA)', },
    { title: 'Banco Hondureño del Café S.A. (BANHCAFE)', },
    { title: 'Banco del País S.A. (BANPAIS)', },
    { title: 'Banco Financiera Comercial Hondureña S.A. (FICOHSA)', },
    { title: 'Banco Lafise Honduras  S.A.', },
    { title: 'Banco Davivienda Honduras S.A.', },
    { title: 'Banco Promérica S.A.', },
    { title: 'Banco de Desarrollo Rural Honduras S.A.', },
    { title: 'Banco Azteca de Honduras S.A.', },
    { title: 'Banco Popular S.A.', },
    { title: 'Banco de América Central Honduras S.A. (BAC) | Honduras', },
    { title: 'Banco de Honduras (Citi Honduras)', },
    { title: 'Banco Nacional de Desarrollo Agrícola (BANADESA)', },
    { title: 'Banco Hondureño para la Producción y la Vivienda (BANHPROVI)', },
];

export default ParticipanteSolicitudesMovil;


